<div class="label-popover-container position-relative">
    <!-- Bouton pour ouvrir le popover -->
    <button class="btn btn-keep px-2 mb-1 mx-auto d-flex align-items-center action-item" (click)="togglePopover()">
      <div class="action-item-icon">
          <i class="fa-regular fa-bookmark"></i>
      </div>
      <div class="action-item-content text-start px-2">
          <span class="action-item-title">{{ 'task_label.popover.keep_action' | translate}}</span>
          <span class="action-item-desc">{{ 'task_action.keep_desc' | translate }}</span>
      </div>
    </button>
  
    <!-- Popover -->
    @if (isPopoverOpen) {
      <div class="popover-backdrop" (click)="togglePopover()"></div>
      <task-assignee-and-label-popover  [context]="'triage'"
                                        [managers]="managers"
                                        [selectedAssignees]="selectedAssignees"
                                        [selectedLabels]="selectedLabels"
                                        (applyAssigneeAndLabelsSelection)="onApply($event)"></task-assignee-and-label-popover>
  }
</div>